import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
  return {
    selectedFileDescription: {
      display: 'flex',
      marginTop: '4px',
      alignItems: 'center',
      backgroundColor: '#D9E8FF',
      padding: '12px 4px',

    },
    fileUlpload: {
      display: 'flex',
      alignItems: 'center',
      position: 'relative',
      '& label': {
        height: '50px !important',
        width: '100% !important',
        maxWidth: 'inherit !important',
      },
    },
    label: {
      fontSize: '13px',
      color: '#455a64',
      marginBottom: 6,
      '&.MuiInputLabel': {
        '&-shrink': {
          transform: 'translate(0, -2px) scale(1)',
        },
      },
    },
    flexColumn: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    containerFileUpload: {
      maxHeight: '400px',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      padding: '18px !important',
    },
    fileLink: {
      width: '100%',
      display: 'flex',
      margin: '8px 0',
      alignItems: 'center',
    },
    contentFile: {
      height: '200px !important',
      'overflow-y': 'auto',
      marginRight: '32px !important',
      marginLeft: '32px !important',
    },
    btnActions: {
      display: 'flex',
      flex: '1',
      justifyContent: 'center',
      fontSize: '11px',
      margin: '4px',
      border: '1px solid #ccc !important',
      borderRadius: '8px !important'
    },
    expandClass: {
      width: '15px',
      height: '15px',
      marginTop: '-5px'
    },

    treeComponent: {
      marginTop: '32px'
    },

    parentIconActio: {
      fontSize: '12px',
    },
    titleBlock: {
      fontSize: '12px',
      margin: '0 3px 12px',
      fontWeight: '400',
      [theme.breakpoints.down('lg')]: {
        marginTop: '16px'
      },

    },
    loadingTreeSubmit: {
      zIndex: '1000',
      position: 'absolute',
      width: '100%',
      height: '100%',
      'background-color': 'transparent',
    },

    checkbox: {
      'font-size': '16px',
      'user-select': 'none',
      'min-height': '320px',
      'padding': '0 20px',
      'box-sizing': 'content-box',
      'height': '380px',
      'overflowY': 'auto',
      'overflowX': 'hidden',
      'scrollbar-width': '12px',
      '&::-webkit-scrollbar': {
        'width': '12px',
        'min-width': '12px',
      },

      '&::-webkit-scrollbar-track': {
        'background': '#fff',
      },

      '&::-webkit-scrollbar-thumb': {
        'background-color': '#4050AC',
        'border-radius': '15px',
      },
      '@media(max-width: 660px)': {
        'height': '300px',
        'padding-left': '24px'
      },
      '& .tree-node, .tree-node-group': {
        'list-style': 'none',
        'margin': '0',
        'padding': '0',
        'margin-right ': '48px',
        '@media(max-width: 550px)': {
          'margin-right ': '20px'
        },
      },
      '& .tree-node-group .tree-leaf-list-item div[disabled]': {
        //'display' : 'none !important'
      },
      '& .tree-node-group .tree-leaf-list-item': {
        '@media(max-width: 660px)': {
          'margin-left': '12px',
        },
      },
      '& .tree': {
        'list-style': 'none',
        'margin': '0',
        'padding': '0',
        'margin-right ': '-48px',
        'font-size': '10px',
      },

      '& .tree-node__leaf': {
        'min-width': '150px',
        'display': 'flex !important',
        'align-items': 'center !important',

      },
      '& .tree-branch-wrapper,  .tree-node__leaf': {
        'outline': 'none'
      },
      '& .tree-node': {
        'cursor': 'pointer',
        'display': 'flex !important',
        'align-items': 'center !important',
      },
      '& .tree-node .name:hover': {
        'border-radius': '4px'
      },
      '&  .name': {
        'display': 'inline-block'
      },
      '& .tree-node': {
        'display': 'inline-block'
      },

      '& .checkbox-icon': {
        'vertical-align': 'middle',
      },

      '& button': {
        'border': 'none',
        'background': 'transparent',
        'cursor': 'pointer',
      },

      '& .arrow': {
        'margin-left': '5px',
        'vertical-align': 'middle',
      },

      '& .arrow--open': {
        'transform': 'rotate(90deg)'
      },
      '& .tree-node__branch': {
        'display': 'flex',
        'align-items': 'center',
        //'padding-left': '10px',
        'margin-left': '33px',
      }
    },
    checkboxs: {
      marginTop: '8px',
      display: 'flex',
      flexDirection: 'column',
    },
    rightBox: {
      padding: '22px 32px 0',
      border: '1px solid #dfdfdf',
      borderRadius: '8px 0 0 8px',
      height: '500px',
      overflow: 'hidden',
      [theme.breakpoints.down('lg')]: {
        borderRadius: '8px',
        marginBottom: '4px'
      },
    },
    leftBox: {
      padding: '32px',
      border: '1px solid #dfdfdf',
      borderLeft: 'none',
      borderRadius: '0  8px  8px 0',
      backgroundColor: '#fafafa',
      height: '500px',
      overflow: 'hidden',

      '@media(max-width: 660px)': {
        'height': 'auto',
      },
      [theme.breakpoints.down('lg')]: {
        border: '1px solid #ccc',
        borderRadius: '8px',
      },
      '& .checkbox': {
        height: 'auto',

      }
    },

    customChip: {
      margin: '2px 8px',
      height: '24px',
    },

  };

});